import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type UpdateAccountLegalDetailsMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateAccountLegalDetailsInput;
}>;

export type UpdateAccountLegalDetailsMutationResult = { __typename?: 'Mutation' } & {
  updateAccountLegalDetails?: GraphQLTypes.Maybe<
    { __typename?: 'UpdateAccountLegalDetailsPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const UpdateAccountLegalDetailsDocument = gql`
  mutation UpdateAccountLegalDetails($input: UpdateAccountLegalDetailsInput!) {
    updateAccountLegalDetails(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
